<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

const props = defineProps<{
  text: string
  href?: string
  to?: RouteLocationRaw
  menuCategory1?: string
  menuCategory2?: string
}>();

const emit = defineEmits<{
  click: []
}>();

const { linkComponent, linkBindings } = useLinksBuilder(props);

function onClick() {
  if (props.menuCategory1) {
    trackEvent({
      event: 'menu_interaction',
      event_name: 'footer_click',
      menu_category1: props.menuCategory1,
      menu_category2: props.menuCategory2,
    });
  }
  emit('click');
}
</script>

<template>
  <component
    :is="linkComponent"
    v-bind="linkBindings"
    :target="linkComponent === 'a' ? '_blank' : undefined"
    class="hover:text-secondary-30"
    @click="onClick"
  >
    {{ text }}
  </component>
</template>
